(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mf-mobile-ux"] && !Shopify.designMode) return;
  try {
    const mfDialogTriggers = new WeakMap();
  document.addEventListener('change', event => {
    if (!(event.target instanceof HTMLInputElement)) return;
    const picker = event.target.closest('variant-picker');
    if (!picker || !event.target.dataset.optionName?.toLowerCase().includes('size')) return;
    const scope = picker.closest('.shopify-section, dialog');
    const text = picker.dataset.addToCartText || 'Add to cart';
    for (const button of scope?.querySelectorAll('button[name="add"]') || []) {
      if (!(button instanceof HTMLButtonElement)) continue;
      button.disabled = false;
      const label = button.querySelector('.add-to-cart-text__content > span:first-child');
      if (label) {
        label.textContent = text;
      } else {
        const textNode = [...button.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent?.trim());
        if (textNode) textNode.textContent = `\n${text}\n`;
      }
    }
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-mf-open-guide]');
    if (trigger) {
      const scope = trigger.closest('quick-add-dialog') || trigger.closest('.shopify-section');
      const dialog = scope?.querySelector('[data-mf-size-dialog]');
      if (dialog instanceof HTMLDialogElement) {
        mfDialogTriggers.set(dialog, {trigger, x: window.scrollX, y: window.scrollY});
        dialog.showModal();
        dialog.addEventListener('close', () => {
          const state = mfDialogTriggers.get(dialog);
          state?.trigger.focus({preventScroll:true});
          if (state) window.scrollTo(state.x, state.y);
        }, {once:true});
      }
    }
    const close = event.target.closest('[data-mf-size-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('[data-mf-size-dialog]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('scroll', event => {
    const list = event.target;
    if (!(list instanceof Element) || !list.matches('.mf-product-photos__list')) return;
    const items = [...list.children];
    const left = list.getBoundingClientRect().left;
    const distances = items.map(item => Math.abs(item.getBoundingClientRect().left-left));
    const current = distances.indexOf(Math.min(...distances))+1;
    const counter = list.parentElement.querySelector('[data-mf-gallery-progress]');
    if (counter) counter.textContent = current+' / '+items.length;
  }, true);
  } catch(e) { console.error(e); }
})();

})();
